export default {
  'file-management.root': '根目录',
  'file-management.storageConfig': '存储配置',
  'file-management.selectStorageConfig': '选择存储配置',
  'file-management.storageSelector.defaultConfig': '默认配置',
  'file-management.storageSelector.currentSelection': '当前选择',
  'file-management.storageSelector.scopeHint': '切换仅影响当前页面的数据视角',
  'file-management.allStorageConfigs': '所有存储配置',
  'file-management.refreshData': '刷新数据',
  'file-management.createDefaultConfig': '创建默认配置',
  'file-management.builtIn': '内置',
  'file-management.systemDefault': '系统默认配置',
  'file-management.createDefaultConfigDescription':
    '创建一个 1GB 的基础存储配置，让您立即开始使用职阅云存储',
  'file-management.storageType': '存储类型',
  'file-management.activated': '已激活',
  'file-management.inactive': '未激活',
  'file-management.dashboard.heading': '仪表盘',
  'file-management.dashboard.subtitle': '查看存储指标和系统概览',
  'file-management.dashboard.defaultTag': '默认',
  'file-management.dashboard.switchStorage': '切换存储',
  'file-management.dashboard.quota.full': '存储空间已满，不允许上传',
  'file-management.dashboard.quota.high': '存储空间使用率高，建议清理文件',
  'file-management.dashboard.quota.ok': '存储容量充足',
  'file-management.dashboard.unknownAuthor': '未知',
  'file-management.dashboard.stats.totalFiles': '文件总数',
  'file-management.dashboard.stats.totalFolders': '文件夹',
  'file-management.dashboard.stats.totalSize': '总大小',
  'file-management.dashboard.stats.todayUploads': '今日上传',
  'file-management.dashboard.storageUsage.title': '存储使用情况',
  'file-management.dashboard.storageUsage.loading': '加载中...',
  'file-management.dashboard.storageUsage.used': '已使用',
  'file-management.dashboard.storageUsage.total': '总容量',
  'file-management.dashboard.storageUsage.remaining': '剩余',
  'file-management.dashboard.activity.title': '今日活动',
  'file-management.dashboard.activity.downloads': '下载',
  'file-management.dashboard.activity.views': '查看',
  'file-management.dashboard.activity.uploads': '上传',
  'file-management.dashboard.storageAlerts.title': '存储警报',
  'file-management.dashboard.storageAlerts.resolve': '立即解决',
  'file-management.dashboard.fileType.title': '文件类型分布',
  'file-management.dashboard.fileType.column.type': '文件类型',
  'file-management.dashboard.fileType.column.count': '数量',
  'file-management.dashboard.fileType.column.size': '总大小',
  'file-management.dashboard.fileType.column.percent': '占比',
  'file-management.dashboard.userUpload.title': '用户上传统计',
  'file-management.dashboard.userUpload.column.userId': '用户名称',
  'file-management.dashboard.userUpload.column.count': '文件',
  'file-management.dashboard.userUpload.column.size': '总大小',
  'file-management.dashboard.userUpload.column.percent': '占比',
  'file-management.dashboard.cleanup.title': '清理建议',
  'file-management.dashboard.cleanup.savingsLabel': '节省 {amount}',
  'file-management.dashboard.cleanup.suggestionList': '建议文件：',
  'file-management.dashboard.cleanup.more': '以及 {count} 个更多文件...',
  'file-management.dashboard.cleanup.largeFiles.title': '大文件清理建议',
  'file-management.dashboard.cleanup.largeFiles.description':
    '发现 {count} 个超过 100MB 的大文件，建议清理以释放存储空间',
  'file-management.dashboard.cleanup.unusedFiles.title': '未使用文件清理建议',
  'file-management.dashboard.cleanup.unusedFiles.description':
    '发现 {count} 个 90 天未访问的文件，建议归档或删除',
  'file-management.dashboard.cleanup.duplicateFiles.title': '重复文件清理建议',
  'file-management.dashboard.cleanup.duplicateFiles.description':
    '发现 {count} 个重复文件组，建议删除重复文件',
  'file-management.dashboard.cleanup.duplicateFiles.groupLabel':
    '（{count} 个重复，每个 {size}）',
  'file-management.dashboard.recentFiles.title': '最近访问的文件',
  'file-management.dashboard.recentFiles.view': '查看',
  'file-management.dashboard.recentFiles.download': '下载',
  'file-management.uploadCenter.placeholder.selectFolder':
    '选择文件夹（默认上传到根目录）',
  'file-management.uploadCenter.field.storageLabel': '选择存储配置',
  'file-management.search.title': '文件搜索',
  'file-management.search.description': '快速搜索和定位文件',
  'file-management.search.action.search': '搜索',
  'file-management.search.total': '找到 {count} 个文件',
  'file-management.search.empty': '未找到文件',
  'file-management.search.placeholder.keyword': '请输入关键词搜索',
  'file-management.search.placeholder.fileType': '选择文件类型',
  'file-management.search.placeholder.category': '选择分类',
  'file-management.search.placeholder.storageConfig': '选择存储配置',
  'file-management.search.placeholder.sort': '排序方式',
  'file-management.search.pagination.showTotal':
    '第 {start}-{end}条/总共 {total} 条',
  'file-management.search.action.view': '查看',
  'file-management.search.action.download': '下载',
  'file-management.search.action.edit': '编辑',
  'file-management.search.action.share': '分享',
  'file-management.search.modal.title': '编辑文件信息',
  'file-management.search.modal.field.name': '文件名：',
  'file-management.search.modal.field.description': '描述：',
  'file-management.search.modal.field.category': '类别：',
  'file-management.search.modal.field.tags': '标签：',
  'file-management.search.modal.placeholder.tags': '输入标签并按 Enter',
  'file-management.search.category.document': '文档',
  'file-management.search.category.image': '图片',
  'file-management.search.category.video': '视频',
  'file-management.search.category.audio': '音频',
  'file-management.search.category.archive': '压缩包',
  'file-management.search.category.other': '其他',
  'file-management.search.sort.updatedDesc': '最新更新',
  'file-management.search.sort.updatedAsc': '最早更新',
  'file-management.search.sort.createdDesc': '最新创建',
  'file-management.search.sort.createdAsc': '最早创建',
  'file-management.search.sort.nameAsc': '名称 (A-Z)',
  'file-management.search.sort.nameDesc': '名称 (Z-A)',
  'file-management.search.sort.sizeDesc': '大小 (从大到小)',
  'file-management.search.sort.sizeAsc': '大小 (从小到大)',
  'file-management.tab.storageConfig': '存储接入',
  'file-management.storageConfig.pageTitle': '存储接入',
  'file-management.storageConfig.status.default': '默认配置',
  'file-management.settings.pageTitle': '⚙️ 设置',
  'file-management.settings.pageDescription':
    '配置职阅云存储首选项和个性化设置',
  'file-management.settings.card.fileTypes.title': '文件类型设置',
  'file-management.settings.card.fileTypes.unsavedTag': '未保存的更改',
  'file-management.settings.card.fileTypes.resetButton': '重置选择',
  'file-management.settings.card.fileTypes.unsavedTip':
    '💡 您的选择已保存到本地。点击 "保存设置" 将更改应用到服务器。',
  'file-management.settings.card.fileTypes.validation.empty':
    '未选择文件类型。保存前请至少选择一种文件类型。',
  'file-management.settings.card.fileTypes.selectByCategory':
    '按类别选择文件类型：',
  'file-management.settings.card.fileTypes.tag.selected': '已选择 {count}',
  'file-management.settings.card.fileTypes.button.selectAll': '全选',
  'file-management.settings.card.fileTypes.button.deselectAll': '取消全选',
  'file-management.settings.card.fileTypes.validation.required':
    '⚠️ 请至少选择一种文件类型',
  'file-management.settings.fileTypeCategory.document': '文档',
  'file-management.settings.fileTypeCategory.image': '图片',
  'file-management.settings.fileTypeCategory.video': '视频',
  'file-management.settings.fileTypeCategory.audio': '音频',
  'file-management.settings.fileTypeCategory.code': '代码',
  'file-management.settings.fileTypeCategory.archive': '压缩包',
  'file-management.settings.fileTypeCategory.database': '数据库',
  'file-management.settings.fileTypeCategory.font': '字体',
  'file-management.settings.fileTypeCategory.other': '其他',
  'file-management.settings.card.upload.title': '上传设置',
  'file-management.settings.field.maxFileSize': '最大文件大小 (MB)',
  'file-management.settings.field.maxFilesPerBatch': '每批最大文件数',
  'file-management.settings.field.autoCompress': '自动压缩',
  'file-management.settings.field.enableDragDrop': '启用拖放上传',
  'file-management.settings.card.download.title': '下载设置',
  'file-management.settings.field.enableDownload': '启用下载',
  'file-management.settings.field.requireConfirmation': '下载前需要确认',
  'file-management.settings.field.maxConcurrentDownloads': '最大并发下载数',
  'file-management.settings.card.storage.title': '存储设置',
  'file-management.settings.field.autoBackup': '自动备份',
  'file-management.settings.field.backupInterval': '备份间隔 (小时)',
  'file-management.settings.field.retentionDays': '保留天数',
  'file-management.settings.field.enableCompression': '启用压缩',
  'file-management.settings.card.notification.title': '通知设置',
  'file-management.settings.field.emailNotifications': '邮件通知',
  'file-management.settings.field.uploadNotifications': '上传通知',
  'file-management.settings.field.downloadNotifications': '下载通知',
  'file-management.settings.field.securityAlerts': '安全警报',
  'file-management.settings.card.system.title': '系统信息与操作',
  'file-management.settings.system.appVersion': '应用版本',
  'file-management.settings.system.appVersionTag': 'v1.0.0',
  'file-management.settings.system.dbVersion': '数据库版本',
  'file-management.settings.system.dbVersionTag': 'v1.0.0',
  'file-management.settings.system.apiVersion': 'API 版本',
  'file-management.settings.system.apiVersionTag': 'v1.0.0',
  'file-management.settings.placeholder.maxFileSize': '请输入最大文件大小',
  'file-management.settings.placeholder.maxFilesPerBatch':
    '请输入每批最大文件数',
  'file-management.settings.placeholder.maxConcurrentDownloads':
    '请输入最大并发下载数',
  'file-management.settings.placeholder.backupInterval': '请输入备份间隔',
  'file-management.settings.placeholder.retentionDays': '请输入保留天数',
  'file-management.settings.button.saveWithFileTypeChanges':
    '保存设置（包括文件类型更改）',
  'file-management.settings.button.save': '保存设置',
  'file-management.settings.button.refresh': '刷新设置',
  'file-management.settings.button.export': '导出设置',
  'file-management.settings.button.import': '导入设置',
  'file-management.settings.button.reset': '重置设置',
  'file-management.settings.fetchFailed': '获取文件设置失败',
  'file-management.settings.updateSuccess': '文件设置更新成功',
  'file-management.settings.updateFailed': '更新文件设置失败',
  'file-management.settings.resetSuccess': '文件设置已重置为默认值',
  'file-management.settings.resetFailed': '重置文件设置失败',
  'file-management.action.edit': '编辑文件',
  'file-management.action.delete': '删除文件',
  'file-management.action.view': '查看文件',
  'file-management.action.search': '搜索',
  'file-management.action.refresh': '刷新',
  'file-management.action.more': '更多',
  'file-management.type.document': '文档',
  'file-management.type.image': '图片',
  'file-management.type.video': '视频',
  'file-management.type.audio': '音频',
  'file-management.type.other': '其他',
  'file-management.field.name': '文件名称',
  'file-management.field.type': '文件类型',
  'file-management.field.size': '文件大小',
  'file-management.field.owner': '所有者',
  'file-management.field.modifiedAt': '修改时间',
  'file-management.field.createdAt': '创建时间',
  'file-management.message.operationFailed': '操作失败',
  'file-management.message.settingsLoadFailed': '加载设置失败',
  'file-management.message.settingsSaved': '设置已保存',
  'file-management.message.settingsSaveFailed': '保存设置失败',
  'file-management.message.settingsExported': '设置已导出',
  'file-management.message.settingsExportFailed': '导出设置失败',
  'file-management.message.settingsImported': '设置已导入',
  'file-management.message.settingsImportInvalid': '无效的设置文件',
  'file-management.message.settingsImportFailed': '导入设置失败',
  'file-management.message.settingsReset': '设置已重置为默认值',
  'file-management.message.settingsResetFailed': '重置设置失败',
  'file-management.message.fileTypeReset': '文件类型选择已重置',
  'file-management.message.loadFilesFailed': '加载文件失败',
  'file-management.message.loadConfigDetailFailed': '加载配置详情失败',
  'file-management.message.loadStorageStatsFailed': '加载存储统计失败',
  'file-management.message.cleanupStorageFailed': '清理存储失败',
  'file-management.message.backupStarted': '备份任务已启动',
  'file-management.message.backupStartFailed': '启动备份失败',
  'file-management.message.backupStopped': '备份任务已停止',
  'file-management.message.backupStopFailed': '停止备份失败',
  'file-management.message.loadingStats': '加载统计...',
  'file-management.message.noStatsData': '无统计数据',
  'file-management.message.storageConfigUpdated': '存储配置已更新',
  'file-management.message.pleaseSelectStorageConfig': '请先选择存储配置',
  'file-management.message.viewOfficeInNewWindow': 'Office 文档已在新窗口打开',
  'file-management.message.viewInNewWindow': '文件已在新窗口打开',
  'file-management.message.viewFileFailed': '查看文件失败',
  'file-management.message.downloadDisabled': '下载已禁用',
  'file-management.message.downloadStarted': '文件下载已开始',
  'file-management.message.downloadFailedRetry': '下载失败，请稍后重试',
  'file-management.message.downloadFailed': '下载失败',
  'file-management.message.getFileDetailFailed': '获取文件详情失败',
  'file-management.message.generateShareLinkFailed': '生成分享链接失败',
  'file-management.message.shareFailed': '生成分享链接失败',
  'file-management.message.fileDeleted': '文件已删除',
  'file-management.message.deleteFileFailed': '删除文件失败',
  'file-management.message.deleteFailed': '删除失败',
  'file-management.message.fileInfoUpdated': '文件信息已更新',
  'file-management.message.updateFileInfoFailed': '更新文件信息失败',
  'file-management.message.shareLinkCopied': '分享链接已复制',
  'file-management.message.folderDeleteSuccess': '文件夹删除成功',
  'file-management.message.refreshStorageConfigFailed':
    '刷新存储配置失败，请手动刷新页面',
  'file-management.message.folderCreated': '文件夹创建成功',
  'file-management.message.loadFileDetailFailed': '加载文件详情失败',
  'file-management.message.previewNeedsComponent': '预览需要预览组件',
  'file-management.message.downloadConfirmNeedsDialog': '下载确认需要对话框',
  'file-management.message.editNeedsModal': '编辑功能需要编辑模态框',
  'file-management.message.shareNeedsModal': '分享功能需要分享模态框',
  'file-management.message.shareNeedsDrawer': '分享能力需要接入文件协作抽屉',
  'file-management.message.referenceNeedsDrawer':
    '业务引用能力需要接入文件协作抽屉',
  'file-management.message.folderDeleteConfirmNeedsDialog':
    '文件夹删除确认需要对话框',
  'file-management.message.bucketCreateFailed': '创建存储桶失败',
  'file-management.message.bucketSwitchFailed': '切换存储桶失败',
  'file-management.message.bucketDeleteFailed': '删除存储桶失败',
  'file-management.message.noActiveConfigInDashboard':
    '未找到活动存储配置，请在存储配置中激活一个',
  'file-management.message.initConfigFailedInDashboard': '初始化存储配置失败',
  'file-management.message.loadStatsFailedInDashboard': '加载统计失败',
  'file-management.message.switchConfigFailed': '切换配置失败',
  'file-management.message.loadConfigsFailed': '加载配置失败',
  'file-management.message.defaultConfigCreateSuccess': '默认配置创建成功',
  'file-management.message.defaultConfigCreateFailed': '创建默认配置失败',
  'file-management.message.configNotActive': '此存储配置未激活，无法选择',
  'file-management.message.activateConfigFailed': '激活存储配置失败',
  'file-management.message.activateConfigSuccess': '存储配置已激活',
  'file-management.storageConfig.switchAdminOnly':
    '仅租户/组织管理员可以切换存储配置',
  'file-management.storageConfig.modifyAdminOnlyHint':
    '当前存储配置由管理员统一维护，如需变更请联系管理员。',
  'file-management.message.defaultConfigCreated': '系统默认配置已创建',
  'file-management.message.createDefaultConfigFailed': '创建默认配置失败',
  'file-management.message.noData': '无数据',
  'file-management.message.uploadSuccess': '文件上传成功',
  'file-management.action.download': '下载',
  'file-management.action.share': '分享',
  'file-management.action.reference': '业务引用',
  'file-management.action.createFolder': '创建文件夹',
  'file-management.action.upload': '上传文件',
  'file-management.field.tags': '标签',
  'file-management.column.actions': '操作',
  'file-management.fileLibrary.title': '文件库',
  'file-management.fileLibrary.description': '基于云的文件管理系统',
  'file-management.fileLibrary.header.description':
    '基于 {storageType} 存储的文件管理系统，支持文件夹和文件的完整生命周期管理',
  'file-management.fileLibrary.status.connected': '{name} 已连接',
  'file-management.fileLibrary.status.disconnected': '{name} 未连接',
  'file-management.fileLibrary.status.bucket': '存储桶：{bucket}',
  'file-management.fileLibrary.status.region': '区域：{region}',
  'file-management.fileLibrary.availableConfigCount':
    '检测到 {count} 个存储配置',
  'file-management.fileLibrary.actions.createFolder': '创建文件夹',
  'file-management.fileLibrary.actions.refresh': '刷新文件列表',
  'file-management.fileLibrary.actions.switchStorage': '切换存储',
  'file-management.action.save': '保存',
  'file-management.fileLibrary.actions.uploadFile': '上传文件',
  'file-management.fileLibrary.actions.manageBucket': '管理存储桶',
  'file-management.fileLibrary.actions.manageStorage': '管理存储配置',
  'file-management.fileLibrary.unconfigured.title': '文件库不可用',
  'file-management.fileLibrary.unconfigured.description': '尚未配置存储服务。',
  'file-management.fileLibrary.unconfigured.primaryHint':
    '我们提供 1 GB 的默认存储，让您快速开始。',
  'file-management.fileLibrary.unconfigured.secondaryHint':
    '使用 "配置存储" 创建默认或自定义存储。',
  'file-management.fileLibrary.unconfigured.primaryAction': '配置存储',
  'file-management.fileLibrary.modal.createFolder.title': '创建文件夹',
  'file-management.fileLibrary.modal.createFolder.nameLabel': '文件夹名称',
  'file-management.fileLibrary.modal.createFolder.namePlaceholder':
    '输入文件夹名称',
  'file-management.fileLibrary.modal.createFolder.storageLabel': '存储配置',
  'file-management.fileLibrary.modal.createFolder.storagePlaceholder':
    '选择存储配置（可选）',
  'file-management.fileLibrary.modal.createFolder.storageHint':
    '如果未选择，将使用租户默认配置。',
  'file-management.fileLibrary.modal.createFolder.nameHint':
    '避免特殊字符和重复名称。',
  'file-management.fileLibrary.modal.createFolder.validation.required':
    '请输入文件夹名称',
  'file-management.fileLibrary.modal.createFolder.validation.tooLong':
    '文件夹名称必须为 1-50 个字符',
  'file-management.fileLibrary.modal.createFolder.validation.invalidCharacters':
    '文件夹名称不能包含 < > : " /  | ? *',
  'file-management.fileLibrary.modal.createFolder.validation.leadingOrTrailingDot':
    '文件夹名称不能以点开头或结尾',
  'file-management.fileLibrary.modal.createFolder.validation.consecutiveSpaces':
    '文件夹名称不能包含连续空格',
  'file-management.fileLibrary.modal.createFolder.validation.duplicate':
    '已存在同名文件夹',
  'file-management.fileLibrary.modal.edit.title': '编辑文件信息',
  'file-management.fileLibrary.modal.edit.nameLabel': '文件名称',
  'file-management.fileLibrary.modal.edit.nameRequired': '请输入文件名称',
  'file-management.fileLibrary.modal.edit.namePlaceholder': '请输入文件名称',
  'file-management.fileLibrary.modal.edit.descriptionLabel': '描述',
  'file-management.fileLibrary.modal.edit.descriptionPlaceholder':
    '请输入文件描述',
  'file-management.fileLibrary.modal.edit.categoryLabel': '类别',
  'file-management.fileLibrary.modal.edit.categoryPlaceholder': '选择类别',
  'file-management.fileLibrary.modal.edit.category.document': '文档',
  'file-management.fileLibrary.modal.edit.category.image': '图片',
  'file-management.fileLibrary.modal.edit.category.video': '视频',
  'file-management.fileLibrary.modal.edit.category.audio': '音频',
  'file-management.fileLibrary.modal.edit.category.other': '其他',
  'file-management.fileLibrary.modal.edit.tagsLabel': '标签',
  'file-management.fileLibrary.modal.edit.tagsPlaceholder':
    '输入标签并按 Enter',
  'file-management.fileLibrary.modal.share.title': '分享文件',
  'file-management.fileLibrary.modal.share.fileName': '文件名称',
  'file-management.fileLibrary.modal.share.expiresAt': '过期时间',
  'file-management.fileLibrary.modal.share.link': '分享链接',
  'file-management.fileLibrary.modal.share.copyLink': '复制链接',
  'file-management.fileLibrary.modal.share.close': '关闭',
  'file-management.fileLibrary.modal.upload.title': '上传文件',
  'file-management.fileLibrary.modal.upload.needConfig': '请先选择存储配置',
  'file-management.fileLibrary.modal.bucket.title': '存储桶管理',
  'file-management.fileLibrary.confirm.download.title': '下载文件',
  'file-management.fileLibrary.confirm.download.content':
    '确定要下载此文件吗？',
  'file-management.fileLibrary.confirm.deleteFolder.title': '删除文件夹',
  'file-management.fileLibrary.confirm.deleteFolder.content':
    '确定要删除文件夹 "{name}" 吗？',
  'file-management.fileLibrary.confirm.deleteFolder.attention': '重要提醒',
  'file-management.fileLibrary.confirm.deleteFolder.warning1':
    '删除此文件夹将永久删除其所有内容。',
  'file-management.fileLibrary.confirm.deleteFolder.warning2':
    '此操作不可撤销，可能影响正在进行的工作流程。',
  'file-management.fileLibrary.confirm.deleteFolder.suggestion':
    '请在删除前备份重要文件。',
  'file-management.fileLibrary.confirm.deleteFile.question':
    '确定要删除此文件吗？',
  'file-management.fileLibrary.confirm.deleteFile.title': '删除文件',
  'file-management.fileLibrary.confirm.deleteFile.warning': '此操作不可撤销。',
  'file-management.fileLibrary.confirm.forceDelete.content':
    '文件夹 "{name}" 不为空，包含：',
  'file-management.fileLibrary.confirm.forceDelete.subFolders':
    '{count} 个子文件夹',
  'file-management.fileLibrary.confirm.forceDelete.files': '{count} 个文件',
  'file-management.fileLibrary.confirm.forceDelete.attention': '⚠️ 严重警告',
  'file-management.fileLibrary.confirm.forceDelete.warning1':
    '此文件夹中的所有文件和子文件夹将被永久删除。',
  'file-management.fileLibrary.confirm.forceDelete.warning2':
    '此操作不可撤销，数据恢复将不可能。',
  'file-management.fileLibrary.confirm.forceDelete.warning3':
    '如果其他项目或团队成员依赖这些文件，他们将受到影响。',
  'file-management.fileLibrary.confirm.forceDelete.suggestion':
    '考虑在继续之前备份重要文件。',
  'file-management.fileLibrary.confirm.forceDelete.finalWarning':
    '您确定要继续此不可撤销的操作吗？',
  'file-management.fileLibrary.confirm.forceDelete.confirm': '仍然删除',
  'file-management.fileLibrary.message.uploadFailedWithReason':
    '上传失败：{reason}',
  'file-management.fileLibrary.message.bucketSwitched':
    '已切换到存储桶 {bucket}',
  'file-management.fileLibrary.message.checkFolderContentsFailed':
    '检查文件夹内容失败',
  'file-management.fileLibrary.tree.context.delete': '删除',
  'file-management.fileLibrary.breadcrumb.currentFolder': '当前文件夹',
  'file-management.fileLibrary.breadcrumb.minioStorage': 'MinIO 存储',
  'storage-config.modal.title.create': '创建存储配置',
  'storage-config.modal.title.edit': '编辑存储配置',
  'storage-config.modal.testConnection.button': '测试连接',
  'storage-config.modal.testConnection.failed': '连接测试失败',
  'storage-config.modal.create.success': '存储配置创建成功',
  'storage-config.modal.create.failed': '创建存储配置失败，请检查配置',
  'storage-config.modal.update.success': '存储配置更新成功',
  'storage-config.modal.templates.title': '快速配置模板',
  'storage-config.modal.systemDefault.warning':
    '系统默认配置的存储配额和端点地址不可修改，AccessKey 和 SecretKey 已隐藏',
  'storage-config.modal.form.configName.label': '配置名称',
  'storage-config.modal.form.configName.required': '请输入配置名称',
  'storage-config.modal.form.configName.placeholder': '请输入配置名称',
  'storage-config.modal.form.storageType.label': '存储类型',
  'storage-config.modal.form.storageType.required': '请选择存储类型',
  'storage-config.modal.form.storageType.placeholder': '请选择存储类型',
  'storage-config.modal.form.storageType.qiniu': '七牛云',
  'storage-config.modal.form.storageType.oss': '阿里云 OSS',
  'storage-config.modal.form.description.label': '配置描述',
  'storage-config.modal.form.description.placeholder': '请输入配置描述（可选）',
  'storage-config.modal.form.endpoint.label': '端点地址',
  'storage-config.modal.form.endpoint.required': '请输入端点地址',
  'storage-config.modal.form.endpoint.placeholder':
    '例如：https://s3.amazonaws.com',
  'storage-config.modal.form.endpoint.extra.minio':
    'MinIO 示例：http://minio:9000 或 http://localhost:9000',
  'storage-config.modal.form.endpoint.extra.s3':
    'AWS S3 示例：https://s3.amazonaws.com',
  'storage-config.modal.form.region.label': '区域',
  'storage-config.modal.form.region.placeholder': '例如：us-east-1',
  'storage-config.modal.form.accessKey.label': 'accessKey',
  'storage-config.modal.form.accessKey.required': '请输入 accessKey',
  'storage-config.modal.form.accessKey.placeholder': '请输入 accessKey',
  'storage-config.modal.form.secretKey.label': 'secretKey',
  'storage-config.modal.form.secretKey.required': '请输入 secretKey',
  'storage-config.modal.form.secretKey.placeholder': '请输入 secretKey',
  'storage-config.modal.form.isAdminAccessKey.label': '管理员权限',
  'storage-config.modal.form.isAdminAccessKey.extra':
    '启用管理员权限可创建新的存储桶，无需填写现有桶名称',
  'storage-config.modal.form.bucket.label': '存储桶',
  'storage-config.modal.form.bucket.required.normal': '请输入存储桶名称',
  'storage-config.modal.form.bucket.required.admin':
    '管理员权限下存储桶名称可选，留空将自动创建',
  'storage-config.modal.form.bucket.extra.normal': '请输入现有的存储桶名称',
  'storage-config.modal.form.bucket.extra.admin':
    '管理员权限下，存储桶名称可留空，系统将自动创建新桶',
  'storage-config.modal.form.bucket.placeholder.normal': '请输入存储桶名称',
  'storage-config.modal.form.bucket.placeholder.admin': '留空自动创建新桶',
  'storage-config.modal.form.basePath.label': '基础路径',
  'storage-config.modal.form.basePath.placeholder': '例如：/files',
  'storage-config.modal.form.cdn.label': 'CDN 域名',
  'storage-config.modal.form.cdn.placeholder': '例如：https://cdn.example.com',
  'storage-config.modal.form.storageQuota.label': '存储配额',
  'storage-config.modal.form.storageQuota.required': '请输入存储配额',
  'storage-config.modal.form.storageQuota.range': '存储配额范围为 100MB-50TB',
  'storage-config.modal.form.storageQuota.placeholder': '请输入存储配额',
  'storage-config.modal.form.activateImmediately.label': '立即激活',
  'storage-config.modal.quotaRecommendation.title': '智能推荐',
  'storage-config.modal.quotaRecommendation.currentUsed': '当前使用',
  'storage-config.modal.quotaRecommendation.recommended': '推荐配额',
  'storage-config.modal.quotaRecommendation.apply': '应用推荐',
  'upload.fileList.status.pending': '等待中',
  'upload.fileList.status.uploading': '上传中',
  'upload.fileList.status.success': '成功',
  'upload.fileList.status.error': '失败',
  'upload.fileList.renameHint':
    '提示：您可以在上传前修改文件名，系统将以修改后的名称保存。修改仅在待上传状态下有效。',
  'upload.fileList.overallProgress': '整体进度',
  'file-management.validation.sizeExceedsLimit': '文件大小超过限制 {maxSize}MB',
  'file-management.uploadLimits.fileTypeNotRecognized': '文件类型无法识别',
  'file-management.uploadLimits.fileTypeNotAllowed':
    '文件类型不允许。允许的类型：{types}',
  'file-management.loading.fromCache': '来自缓存',
  // 上传中心页面
  'file-management.uploadCenter.pageTitle': '上传中心',
  'file-management.uploadCenter.pageDescription':
    '上传文件，管理任务，查看进度',
  'file-management.uploadCenter.status.connected': '{name} 已连接',
  'file-management.uploadCenter.status.disconnected': '{name} 未连接',
  'file-management.uploadCenter.card.upload.title': '文件上传',
  'file-management.uploadCenter.label.selectFolder': '选择上传文件夹',
  'file-management.uploadCenter.dragger.text': '点击或拖拽文件到此区域上传',
  'file-management.uploadCenter.dragger.hint': '支持单个或批量上传文件',
  'file-management.uploadCenter.card.tasks.title': '上传任务',
  'file-management.uploadCenter.empty.noTasks': '暂无上传任务',
  'file-management.uploadCenter.button.clearCompleted': '清空已完成',
  'file-management.uploadCenter.action.pause': '暂停',
  'file-management.uploadCenter.action.resume': '恢复',
  'file-management.uploadCenter.action.retry': '重试',
  'file-management.uploadCenter.action.cancel': '取消',
  'file-management.uploadCenter.status.pending': '等待中',
  'file-management.uploadCenter.status.uploading': '上传中',
  'file-management.uploadCenter.status.paused': '已暂停',
  'file-management.uploadCenter.status.completed': '已完成',
  'file-management.uploadCenter.status.error': '错误',
  'file-management.uploadCenter.task.calculating': '计算中...',
  'file-management.uploadCenter.task.completed': '已完成',
  'file-management.uploadCenter.task.remaining': '剩余 {seconds} 秒',
  'file-management.uploadCenter.task.uploadFailed': '上传失败',
  'file-management.uploadCenter.label.currentStorage': '当前存储',
  'file-management.uploadCenter.label.bucket': '存储桶',
  'file-management.uploadCenter.label.region': '区域',
  'file-management.uploadCenter.empty.noStorageConfig': '暂无存储配置',
  'file-management.uploadCenter.button.goToConfig': '前往配置',
  'file-management.uploadCenter.empty.pleaseSelectStorage': '请选择存储配置',
  'file-management.uploadCenter.placeholder.selectStorage': '请选择存储配置',
  'file-management.uploadCenter.message.cleared': '已清空已完成任务',
  // 直接上传组件
  'file-management.directUpload.title': '直接上传',
  'file-management.directUpload.selectFiles': '点击或拖拽选择文件',
  'file-management.directUpload.selectFilesOnly': '点击选择文件',
  'file-management.directUpload.multiFileSupport': '支持多文件上传',
  'file-management.directUpload.dragDropDisabled': '（拖拽上传已禁用）',
  'file-management.directUpload.loadingConfig': '正在加载配置...',
  'file-management.directUpload.configLoadFailed': '配置加载失败：{error}',
  'file-management.directUpload.configNotLoaded':
    '配置未完全加载，使用默认限制（最多 {count} 个文件）',
  'file-management.directUpload.startUpload': '开始上传 ({count})',
  'file-management.directUpload.clear': '清空列表',
  'file-management.directUpload.instructions.title': '使用说明',
  'file-management.directUpload.instructions.step1':
    '点击上方区域或拖拽文件到此处选择文件',
  'file-management.directUpload.instructions.step2': '支持批量上传多个文件',
  'file-management.directUpload.instructions.step3': '上传前可以修改文件名',
  'file-management.directUpload.instructions.step4':
    '点击"开始上传"按钮开始上传文件',
  'file-management.directUpload.message.uploadFailed': '上传失败',
  'file-management.directUpload.message.validationFailed':
    '有 {count} 个文件校验失败：{files}{more}',
  'file-management.directUpload.message.moreFiles': '等 {count} 个文件',
  'file-management.directUpload.message.addSuccess': '成功添加 {count} 个文件',
  'file-management.directUpload.message.noPendingFiles': '没有待上传的文件',
  'file-management.directUpload.message.emptyFileName': '文件名不能为空',
  'file-management.directUpload.message.uploadSuccess':
    '文件 "{filename}" 上传成功',
  'file-management.directUpload.message.batchUploadComplete':
    '所有文件上传成功',
  'file-management.directUpload.message.partialSuccess':
    '部分文件上传失败：{errors}{more}',
  'file-management.directUpload.message.allFailed':
    '所有文件上传失败：{errors}{more}',
  'file-management.directUpload.message.batchUploadFailed': '批量上传失败',
  'file-management.directUpload.message.fileInfoIncomplete': '文件信息不完整',
  'file-management.directUpload.message.getDownloadLinkFailed':
    '获取下载链接失败',
  'file-management.directUpload.message.downloadFailed': '下载失败',
  // 上传文件列表组件
  'upload.fileList.download': '下载',
  'upload.fileList.delete': '删除',
  'upload.fileList.fileNamePlaceholder': '输入文件名',
  'upload.fileList.renamed': '已重命名',
  'upload.fileList.originalName': '原文件名',
  'upload.fileList.speed': '速度',
  'upload.fileList.remaining': '剩余',
  'upload.fileList.uploadSuccess': '上传成功',
  'upload.fileList.uploadFailed': '上传失败',
  'upload.fileList.waiting': '等待上传',
  'upload.fileList.time.second': '秒',
  'upload.fileList.time.minute': '分',
  'upload.fileList.time.hour': '小时',
  // 文件验证相关
  'file-management.validation.noTypeRestriction': '允许所有文件类型',
  'file-management.validation.allowedTypes': '允许的文件类型：{types}',
  'file-management.validation.noSizeLimit': '无文件大小限制',
  'file-management.validation.maxFileSize': '最大文件大小：{size}MB',
  // 上传限制相关
  'file-management.uploadLimits.fileCountExceedsLimit':
    '文件数量超过限制，最多允许 {maxFiles} 个文件',
  'file-management.uploadLimits.configNotLoaded': '配置加载中...',
  'file-management.uploadLimits.description':
    '最大 {maxSize}MB，每批最多 {maxFiles} 个文件',
  // 存储接入页面
  'file-management.storageConfig.pageDescription':
    '管理当前租户的职阅云存储与外部 OSS 接入',
  'file-management.storageConfig.button.create': '创建配置',
  'file-management.storageConfig.button.refresh': '刷新',
  'file-management.storageConfig.delete.confirmTitle': '确认删除',
  'file-management.storageConfig.delete.confirmContent':
    '确定要删除存储配置 "{name}" 吗？此操作不可撤销。',
  'file-management.storageConfig.action.test': '测试连接',
  'file-management.storageConfig.action.edit': '编辑',
  'file-management.storageConfig.action.setDefault': '设为默认',
  'file-management.storageConfig.action.unsetDefault': '取消默认',
  'file-management.storageConfig.action.delete': '删除',
  'file-management.storageConfig.status.admin': '管理员',
  'file-management.storageConfig.status.active': '已激活',
  // 存储配置表格列
  'file-management.storageConfig.table.column.name': '配置名称',
  'file-management.storageConfig.table.column.type': '存储类型',
  'file-management.storageConfig.table.column.endpoint': '端点地址',
  'file-management.storageConfig.table.column.bucket': '存储桶',
  'file-management.storageConfig.table.column.createdAt': '创建时间',
  'file-management.storageConfig.table.column.status': '状态',
  'file-management.storageConfig.table.column.actions': '操作',
  // 存储配置表单
  'file-management.storageConfig.modal.create.title': '创建存储配置',
  'file-management.storageConfig.modal.edit.title': '编辑存储配置',
  'file-management.storageConfig.form.label.configName': '配置名称',
  'file-management.storageConfig.form.placeholder.configName': '请输入配置名称',
  'file-management.storageConfig.form.label.storageType': '存储类型',
  'file-management.storageConfig.form.placeholder.storageType':
    '请选择存储类型',
  'file-management.storageConfig.form.label.endpoint': '端点地址',
  'file-management.storageConfig.form.placeholder.endpoint': '请输入端点地址',
  'file-management.storageConfig.form.label.bucket': '存储桶',
  'file-management.storageConfig.form.placeholder.bucket': '请输入存储桶名称',
  'file-management.storageConfig.form.label.region': '区域',
  'file-management.storageConfig.form.placeholder.region': '请输入区域（可选）',
  'file-management.storageConfig.form.label.accessKey': 'Access Key',
  'file-management.storageConfig.form.placeholder.accessKey':
    '请输入 Access Key',
  'file-management.storageConfig.form.label.secretKey': 'Secret Key',
  'file-management.storageConfig.form.placeholder.secretKey':
    '请输入 Secret Key',
  'file-management.storageConfig.form.placeholder.secretKeyEdit':
    '留空表示不修改',
  'file-management.storageConfig.form.label.basePath': '基础路径',
  'file-management.storageConfig.form.placeholder.basePath':
    '请输入基础路径（可选）',
  'file-management.storageConfig.form.label.cdn': 'CDN 域名',
  'file-management.storageConfig.form.placeholder.cdn':
    '请输入 CDN 域名（可选）',
  'file-management.storageConfig.form.label.storageQuotaValue': '存储配额',
  'file-management.storageConfig.form.placeholder.storageQuotaValue':
    '请输入存储配额',
  'file-management.storageConfig.form.label.storageQuotaUnit': '单位',
  'file-management.storageConfig.form.placeholder.storageQuotaUnit':
    '请选择单位',
  'file-management.storageConfig.form.label.isDefault': '设为默认',
  'file-management.storageConfig.form.label.isAdminAccessKey': '管理员权限',
  // 存储配置提示信息
  'file-management.storageConfig.alert.storageTypeTips': '{type} 配置提示',
  'file-management.storageConfig.alert.minioDescription':
    'MinIO 是一个高性能的对象存储系统，兼容 Amazon S3 API。请确保端点地址可访问，并正确配置 Access Key 和 Secret Key。',
  'file-management.storageConfig.alert.s3Description':
    'AWS S3 是亚马逊提供的对象存储服务。请确保您的账户有权限访问指定的存储桶，并正确配置区域信息。',
  'file-management.storageConfig.alert.ossDescription':
    '阿里云 OSS 是阿里云提供的对象存储服务。请确保您的账户有权限访问指定的存储桶，并正确配置 Endpoint 和区域信息。',
  'file-management.storageConfig.alert.qiniuDescription':
    '七牛云存储是七牛云提供的对象存储服务。请确保您的账户有权限访问指定的存储空间，并正确配置 Access Key 和 Secret Key。',
  'file-management.storageConfig.form.tooltip.isAdminAccessKey':
    '启用管理员权限可以使用管理员 Access Key，拥有创建存储桶等高级权限',
  // 存储桶管理
  'file-management.bucketManagement.title': '存储桶管理',
  'file-management.bucketManagement.refresh': '刷新',
  'file-management.bucketManagement.create': '创建存储桶',
  'file-management.bucketManagement.switch': '切换',
  'file-management.bucketManagement.switchTo': '切换到此存储桶',
  'file-management.bucketManagement.delete': '删除',
  'file-management.bucketManagement.current': '当前',
  'file-management.bucketManagement.permissionDenied': '权限不足',
  'file-management.bucketManagement.permissionDeniedDesc':
    '您需要管理员权限才能管理存储桶。请在存储配置中启用"管理员权限"。',
  'file-management.bucketManagement.column.name': '存储桶名称',
  'file-management.bucketManagement.column.creationDate': '创建时间',
  'file-management.bucketManagement.column.region': '区域',
  'file-management.bucketManagement.column.actions': '操作',
  'file-management.bucketManagement.confirm.delete.title': '删除存储桶',
  'file-management.bucketManagement.confirm.delete.description':
    '此操作将删除存储桶及其所有内容，请谨慎确认。',
  'file-management.bucketManagement.message.createSuccess': '存储桶创建成功',
  'file-management.bucketManagement.message.switchSuccess': '存储桶切换成功',
  'file-management.bucketManagement.message.deleteSuccess': '存储桶删除成功',
  'file-management.bucketManagement.modal.create.title': '创建存储桶',
  'file-management.bucketManagement.modal.create.bucketName': '存储桶名称',
  'file-management.bucketManagement.modal.create.bucketNameRequired':
    '请输入存储桶名称',
  'file-management.bucketManagement.modal.create.bucketNameLength':
    '存储桶名称必须为 3-63 个字符',
  'file-management.bucketManagement.modal.create.bucketNamePattern':
    '存储桶名称只能包含小写字母、数字、点和连字符',
  'file-management.bucketManagement.modal.create.bucketNameStartEnd':
    '存储桶名称不能以点或连字符开头或结尾',
  'file-management.bucketManagement.modal.create.bucketNameConsecutive':
    '存储桶名称不能包含连续的点或连字符',
  'file-management.bucketManagement.modal.create.bucketNameIP':
    '存储桶名称不能是 IP 地址格式',
  'file-management.bucketManagement.modal.create.bucketNamePrefix':
    '存储桶名称不能以保留前缀开头（xn--, sthree-, s3alias）',
  'file-management.bucketManagement.modal.create.bucketNamePlaceholder':
    '请输入存储桶名称（3-63 个字符）',
  'file-management.bucketManagement.modal.create.region': '区域',
  'file-management.bucketManagement.modal.create.accessControl': '访问控制',
  'file-management.bucketManagement.modal.create.accessControl.private': '私有',
  'file-management.bucketManagement.modal.create.accessControl.publicRead':
    '公共读',
  'file-management.bucketManagement.modal.create.accessControl.publicReadWrite':
    '公共读写',
  'file-management.bucketManagement.modal.switch.title': '切换存储桶',
  'file-management.bucketManagement.modal.switch.message': '切换当前存储桶',
  'file-management.bucketManagement.modal.switch.description':
    '切换后，新上传的文件将保存到选中的存储桶，已有文件不受影响。',
  'file-management.bucketManagement.modal.switch.selectBucket': '选择存储桶',
  'file-management.bucketManagement.modal.switch.bucketRequired':
    '请选择存储桶',
  'file-management.bucketManagement.modal.switch.selectBucketPlaceholder':
    '请选择存储桶',
  'file-management.bucketManagement.modal.delete.title': '删除存储桶',
  'file-management.bucketManagement.modal.delete.message': '删除存储桶警告',
  'file-management.bucketManagement.modal.delete.description':
    '此操作将永久删除存储桶及其所有内容，请谨慎操作。',
  'file-management.bucketManagement.modal.delete.bucketName': '存储桶名称',
  'file-management.bucketManagement.modal.delete.forceDelete': '强制删除',
  'file-management.bucketManagement.modal.delete.forceDeleteExtra':
    '强制删除将清空存储桶中的所有文件',
  'file-management.bucketManagement.modal.delete.forceDeleteNo':
    '否（仅删除空存储桶）',
  'file-management.bucketManagement.modal.delete.forceDeleteYes':
    '是（删除存储桶及所有文件）',
  'file-management.bucketManagement.modal.delete.confirm': '确认删除',
  // 缺少的翻译键 - 创建文件夹
  'file-management.createFolder.title': '创建文件夹',
  'file-management.createFolder.folderName': '文件夹名称',
  'file-management.createFolder.folderNamePlaceholder': '请输入文件夹名称',
  'file-management.createFolder.storageConfig': '存储配置',
  'file-management.createFolder.storageConfigPlaceholder':
    '选择存储配置（可选）',
  'file-management.createFolder.hint.defaultConfig':
    '如果未选择，将使用默认配置',
  'file-management.createFolder.hint.namingRules': '避免使用特殊字符和重复名称',
  'file-management.createFolder.create': '创建',
  'file-management.createFolder.cancel': '取消',
  // 缺少的翻译键 - 下载管理器
  'file-management.downloadManager.title': '下载管理器',
  'file-management.downloadManager.noTasks': '暂无下载任务',
  'file-management.downloadManager.progress': '进度',
  'file-management.downloadManager.duration': '耗时',
  'file-management.downloadManager.error': '错误',
  'file-management.downloadManager.action.pause': '暂停',
  'file-management.downloadManager.action.resume': '恢复',
  'file-management.downloadManager.action.cancel': '取消',
  'file-management.downloadManager.action.retry': '重试',
  'file-management.downloadManager.status.pending': '等待中',
  'file-management.downloadManager.status.downloading': '下载中',
  'file-management.downloadManager.status.paused': '已暂停',
  'file-management.downloadManager.status.completed': '已完成',
  'file-management.downloadManager.status.error': '错误',
  'file-management.downloadManager.status.unknown': '未知',
  // 缺少的翻译键 - 空状态
  'file-management.emptyState.title': '暂无数据',
  'file-management.emptyState.subtitle': '开始管理您的对象',
  'file-management.emptyState.noConfig.title': '未配置存储',
  'file-management.emptyState.noConfig.description':
    '您需要先配置存储服务才能使用职阅云存储',
  'file-management.emptyState.noConfig.createConfig': '创建配置',
  'file-management.emptyState.noConfig.createDefault': '创建默认配置',
  'file-management.emptyState.noSelectedConfig.title': '未选择存储配置',
  'file-management.emptyState.noSelectedConfig.description':
    '请选择一个存储配置以开始管理文件',
  'file-management.emptyState.noSelectedConfig.selectConfig': '选择配置',
  'file-management.emptyState.noSelectedConfig.manageConfig': '管理配置',
  'file-management.emptyState.notConnected.title': '存储服务未连接',
  'file-management.emptyState.notConnected.description':
    '无法连接到存储服务，请检查配置',
  'file-management.emptyState.notConnected.hint':
    '提示：检查网络连接和存储服务状态',
  'file-management.emptyState.notConnected.benefit':
    '使用云存储可以安全地保存和管理您的文件',
  'file-management.emptyState.notConnected.configure': '配置存储',
  'file-management.emptyState.notConnected.manage': '管理存储',
  // 缺少的翻译键 - 字段
  'file-management.field.description': '描述',
  'file-management.field.category': '分类',
  'file-management.field.visibility': '可见性',
  'file-management.field.originalName': '原始文件名',
  'file-management.visibility.private': '个人私有',
  'file-management.visibility.organization': '组织共享',
  'file-management.visibility.tenant': '企业公共',
  'file-management.scope.private.title': '个人文件',
  'file-management.scope.organization.title': '组织文件',
  'file-management.scope.tenant.title': '企业公共文件',
  'file-management.scope.private.hint':
    '个人文件：仅自己可见和管理；owner/admin 可因企业管理权限介入。',
  'file-management.scope.organization.hint':
    '组织文件：同组织成员可查看、上传、改名、移动、删除。',
  'file-management.scope.tenant.hint.admin':
    '企业公共文件：全企业成员可查看和下载；你当前可上传和管理。',
  'file-management.scope.tenant.hint.member':
    '企业公共文件：你当前只有查看和下载权限，上传和修改仅 owner/admin 可用。',
  // 缺少的翻译键 - 文件编辑
  'file-management.fileEdit.title': '编辑文件',
  'file-management.fileEdit.fileName': '文件名',
  'file-management.fileEdit.fileNamePlaceholder': '请输入文件名',
  'file-management.fileEdit.fileNameRequired': '请输入文件名',
  'file-management.fileEdit.fileNameMaxLength': '文件名不能超过100个字符',
  'file-management.fileEdit.description': '描述',
  'file-management.fileEdit.descriptionPlaceholder': '请输入文件描述',
  'file-management.fileEdit.descriptionMaxLength': '描述不能超过500个字符',
  'file-management.fileEdit.category': '类别',
  'file-management.fileEdit.categoryPlaceholder': '选择类别',
  'file-management.fileEdit.categoryRequired': '请选择类别',
  'file-management.fileEdit.category.document': '文档',
  'file-management.fileEdit.category.image': '图片',
  'file-management.fileEdit.category.video': '视频',
  'file-management.fileEdit.category.audio': '音频',
  'file-management.fileEdit.category.archive': '压缩包',
  'file-management.fileEdit.category.other': '其他',
  'file-management.fileEdit.tags': '标签',
  'file-management.fileEdit.tagsPlaceholder': '输入标签并按回车',
  'file-management.fileEdit.tagsExtra': '添加标签以便更好地组织文件',
  'file-management.fileEdit.save': '保存',
  'file-management.fileEdit.cancel': '取消',
  // 缺少的翻译键 - 文件列表表格
  'file-management.fileListTable.column.name': '名称',
  'file-management.fileListTable.column.size': '大小',
  'file-management.fileListTable.column.lastModified': '最后修改',
  'file-management.fileListTable.column.author': '作者',
  'file-management.fileListTable.column.tags': '标签',
  'file-management.fileListTable.column.action': '操作',
  'file-management.fileListTable.search.placeholder': '搜索文件...',
  'file-management.fileListTable.filter.fileType.placeholder': '文件类型',
  'file-management.fileListTable.filter.fileType.pdf': 'PDF',
  'file-management.fileListTable.filter.fileType.docx': 'Word',
  'file-management.fileListTable.filter.fileType.xlsx': 'Excel',
  'file-management.fileListTable.filter.fileType.psd': 'PSD',
  'file-management.fileListTable.filter.more': '更多筛选',
  'file-management.fileListTable.refresh': '刷新',
  'file-management.fileListTable.pagination.showTotal': '共 {total} 条',
  // 缺少的翻译键 - 文件预览
  'file-management.filePreview.title': '文件预览',
  'file-management.filePreview.close': '关闭',
  'file-management.filePreview.download': '下载',
  'file-management.filePreview.fullscreen': '全屏',
  'file-management.filePreview.openInNewWindow': '在新窗口打开',
  'file-management.filePreview.notSupported': '不支持的文件类型',
  'file-management.filePreview.notSupportedDesc':
    '该文件类型暂不支持预览，请下载后查看',
  'file-management.filePreview.unsupportedType': '不支持的类型',
  'file-management.filePreview.unsupportedTypeDesc': '无法预览此类型的文件',
  'file-management.filePreview.failed': '预览失败',
  'file-management.filePreview.generating': '正在生成预览...',
  'file-management.filePreview.generateFailed': '生成预览失败',
  'file-management.filePreview.getInfoFailed': '获取文件信息失败',
  'file-management.filePreview.imageLoadFailed': '图片加载失败',
  'file-management.filePreview.pdfLoadFailed': 'PDF 加载失败',
  'file-management.filePreview.audioLoadFailed': '音频加载失败',
  'file-management.filePreview.videoLoadFailed': '视频加载失败',
  'file-management.filePreview.textLoadFailed': '文本加载失败',
  'file-management.filePreview.browserNotSupportAudio':
    '您的浏览器不支持音频播放',
  'file-management.filePreview.browserNotSupportVideo':
    '您的浏览器不支持视频播放',
  'file-management.filePreview.officePreview': 'Office 预览',
  'file-management.filePreview.officeDesc1': 'Office 文档将在新窗口中打开',
  'file-management.filePreview.officeDesc2': '请确保允许弹出窗口',
  // 缺少的翻译键 - 文件夹树
  'file-management.folderTree.root': '根目录',
  'file-management.folderTree.files': '文件',
  'file-management.folderTree.subFolders': '子文件夹',
  // 缺少的翻译键 - 加载中
  'file-management.loading.loading': '加载中...',
  'file-management.loading.loadingData': '正在加载数据...',
  // 缺少的翻译键 - 消息提示
  'file-management.message.configCreated': '配置创建成功',
  'file-management.message.configUpdated': '配置更新成功',
  'file-management.message.configDeleted': '配置删除成功',
  'file-management.message.connectionSuccess': '连接成功',
  'file-management.message.connectionFailed': '连接失败',
  'file-management.message.saveConfigFailed': '保存配置失败',
  'file-management.message.deleteConfigFailed': '删除配置失败',
  'file-management.message.defaultConfigSet': '已设为默认配置',
  'file-management.message.defaultConfigUnset': '已取消默认配置',
  'file-management.message.toggleDefaultFailed': '切换默认配置失败',
  'file-management.message.officeDocumentOpened': 'Office 文档已在新窗口打开',
  // 缺少的翻译键 - 分享文件
  'file-management.shareFile.title': '分享文件',
  'file-management.shareFile.fileName': '文件名',
  'file-management.shareFile.shareLink': '分享链接',
  'file-management.shareFile.expiresAt': '过期时间',
  'file-management.shareFile.copyLink': '复制链接',
  // 缺少的翻译键 - 存储配置删除确认
  'file-management.storageConfig.delete.okText': '删除',
  'file-management.storageConfig.delete.cancelText': '取消',
  'file-management.storageConfig.delete.warning': '警告：此操作不可撤销',
  // 缺少的翻译键 - 存储配置表单验证
  'file-management.storageConfig.form.validation.configNameRequired':
    '请输入配置名称',
  'file-management.storageConfig.form.validation.storageTypeRequired':
    '请选择存储类型',
  'file-management.storageConfig.form.validation.endpointRequired':
    '请输入端点地址',
  'file-management.storageConfig.form.validation.accessKeyRequired':
    '请输入 Access Key',
  'file-management.storageConfig.form.validation.secretKeyRequired':
    '请输入 Secret Key',
  'file-management.storageConfig.form.validation.bucketRequired':
    '请输入存储桶名称',
  'file-management.storageConfig.form.validation.storageQuotaValueRequired':
    '请输入存储配额',
  'file-management.storageConfig.form.validation.storageQuotaUnitRequired':
    '请选择存储配额单位',
  // 缺少的翻译键 - 存储配置详情
  'file-management.storageConfigDetail.title': '存储配置详情',
  'file-management.storageConfigDetail.basicInfo': '基本信息',
  'file-management.storageConfigDetail.configName': '配置名称',
  'file-management.storageConfigDetail.storageType': '存储类型',
  'file-management.storageConfigDetail.endpoint': '端点地址',
  'file-management.storageConfigDetail.bucket': '存储桶',
  'file-management.storageConfigDetail.region': '区域',
  'file-management.storageConfigDetail.basePath': '基础路径',
  'file-management.storageConfigDetail.cdn': 'CDN 域名',
  'file-management.storageConfigDetail.quota': '存储配额',
  'file-management.storageConfigDetail.status': '状态',
  'file-management.storageConfigDetail.status.default': '默认',
  'file-management.storageConfigDetail.status.active': '已激活',
  'file-management.storageConfigDetail.status.inactive': '未激活',
  'file-management.storageConfigDetail.status.currentActive': '当前激活',
  'file-management.storageConfigDetail.createdAt': '创建时间',
  'file-management.storageConfigDetail.lastSync': '最后同步',
  'file-management.storageConfigDetail.usageStats': '使用统计',
  'file-management.storageConfigDetail.totalFiles': '文件总数',
  'file-management.storageConfigDetail.totalSize': '总大小',
  'file-management.storageConfigDetail.used': '已使用',
  'file-management.storageConfigDetail.usedLabel': '已用',
  'file-management.storageConfigDetail.remainingLabel': '剩余',
  'file-management.storageConfigDetail.usageRate': '使用率',
  'file-management.storageConfigDetail.healthStatus': '健康状态',
  'file-management.storageConfigDetail.healthy': '健康',
  'file-management.storageConfigDetail.unhealthy': '不健康',
  'file-management.storageConfigDetail.accessible': '可访问',
  'file-management.storageConfigDetail.notAccessible': '不可访问',
  'file-management.storageConfigDetail.notSet': '未设置',
  'file-management.storageConfigDetail.notSynced': '未同步',
  'file-management.storageConfigDetail.checkStatus': '检查状态',
  'file-management.storageConfigDetail.cleanup': '清理存储',
  'file-management.storageConfigDetail.cleanupSuccess': '清理成功',
  'file-management.storageConfigDetail.cleanupFailed': '清理失败',
  'file-management.storageConfigDetail.loadFailed': '加载详情失败',
  'file-management.storageConfigDetail.actions': '操作',
  'file-management.storageConfig.systemDefault.hidden': '系统配置（不可查看）',
  'file-management.storageConfig.action.view': '查看',
  'file-management.storageConfig.modal.view.title': '查看存储配置',
  'file-management.storageConfig.table.column.usage': '存储用量',
  // 缺少的翻译键 - 存储扩容
  'file-management.storageExpansion.title': '存储扩容',
  'file-management.storageExpansion.selectCapacity.title': '选择容量',
  'file-management.storageExpansion.selectCapacity.currentUsage': '当前使用',
  'file-management.storageExpansion.selectCapacity.selectLabel': '选择扩容容量',
  'file-management.storageExpansion.selectCapacity.custom': '自定义',
  'file-management.storageExpansion.selectCapacity.customLabel': '自定义容量',
  'file-management.storageExpansion.selectCapacity.customFlexible':
    '灵活选择您需要的容量',
  'file-management.storageExpansion.selectCapacity.expandedTotal':
    '扩容后总容量',
  'file-management.storageExpansion.selectCapacity.price': '价格',
  'file-management.storageExpansion.selectCapacity.warning':
    '注意：扩容后无法缩减容量',
  'file-management.storageExpansion.selectCapacity.next': '下一步',
  'file-management.storageExpansion.selectCapacity.cancel': '取消',
  'file-management.storageExpansion.selectCapacity.capacityValue': '容量值',
  'file-management.storageExpansion.payment.title': '支付',
  'file-management.storageExpansion.payment.method': '支付方式',
  'file-management.storageExpansion.payment.methodRequired': '请选择支付方式',
  'file-management.storageExpansion.payment.alipay': '支付宝',
  'file-management.storageExpansion.payment.wechat': '微信支付',
  'file-management.storageExpansion.payment.bank': '银行转账',
  'file-management.storageExpansion.payment.paymentAmount': '支付金额',
  'file-management.storageExpansion.payment.previous': '上一步',
  'file-management.storageExpansion.payment.confirm': '确认支付',
  'file-management.storageExpansion.payment.expansionCapacity': '扩容容量',
  'file-management.storageExpansion.payment.expandedTotal': '扩容后总容量',
  'file-management.storageExpansion.success.title': '扩容成功',
  'file-management.storageExpansion.success.message': '您的存储空间已成功扩容',
  'file-management.storageExpansion.success.thanks': '感谢您的使用',
  'file-management.storageExpansion.message.success': '存储扩容成功',
  'file-management.storageExpansion.message.paymentFailed': '支付失败，请重试',
  // 缺少的翻译键 - 存储配额推荐
  'file-management.storageQuota.recommendation.smallUsage': '使用量较小',
  'file-management.storageQuota.recommendation.oneGB': '1 GB',
  'file-management.storageQuota.recommendation.twoGB': '2 GB',
  'file-management.storageQuota.recommendation.fiveGB': '5 GB',
  'file-management.storageQuota.recommendation.tenGB': '10 GB',
  'file-management.storageQuota.recommendation.twentyGB': '20 GB',
  'file-management.storageQuota.recommendation.fiftyGB': '50 GB',
  'file-management.storageQuota.recommendation.hundredGB': '100 GB',
  'file-management.storageQuota.recommendation.twoHundredGB': '200 GB',
  'file-management.storageQuota.recommendation.custom': '自定义',
  // 存储配额显示
  'file-management.storageQuota.title': '存储配额',
  'file-management.storageQuota.used': '已使用',
  'file-management.storageQuota.totalQuota': '总配额',
  'file-management.storageQuota.remaining': '剩余',
  'file-management.storageQuota.warning.critical': '存储空间严重不足',
  'file-management.storageQuota.warning.high': '存储空间使用率较高',
  'file-management.storageQuota.status.sufficient': '充足',
  'file-management.storageQuota.status.tight': '紧张',
  'file-management.storageQuota.status.critical': '严重不足',
  'file-management.storageQuota.status.adequate': '充足',
  'file-management.storageQuota.status.insufficient': '不足',
  'file-management.storageQuota.validation.mustBeGreaterThanZero': '必须大于零',
  'file-management.storageQuota.validation.cannotBeLessThan': '不能小于 {min}',
  'file-management.storageQuota.validation.cannotBeGreaterThan':
    '不能大于 {max}',
  // 文件类型翻译
  // 文档类型
  'file-management.fileTypes.pdf': 'PDF文档',
  'file-management.fileTypes.doc': 'Word文档',
  'file-management.fileTypes.docx': 'Word文档',
  'file-management.fileTypes.xls': 'Excel表格',
  'file-management.fileTypes.xlsx': 'Excel表格',
  'file-management.fileTypes.ppt': 'PowerPoint演示',
  'file-management.fileTypes.pptx': 'PowerPoint演示',
  'file-management.fileTypes.txt': '文本文件',
  'file-management.fileTypes.md': 'Markdown文档',
  'file-management.fileTypes.rtf': 'RTF文档',
  'file-management.fileTypes.csv': 'CSV数据',
  'file-management.fileTypes.epub': 'EPUB电子书',
  'file-management.fileTypes.eml': '邮件文件',
  // 图片类型
  'file-management.fileTypes.jpg': 'JPEG图片',
  'file-management.fileTypes.jpeg': 'JPEG图片',
  'file-management.fileTypes.png': 'PNG图片',
  'file-management.fileTypes.gif': 'GIF动图',
  'file-management.fileTypes.bmp': 'BMP图片',
  'file-management.fileTypes.webp': 'WebP图片',
  'file-management.fileTypes.svg': 'SVG矢量图',
  'file-management.fileTypes.tiff': 'TIFF图片',
  'file-management.fileTypes.tif': 'TIFF图片',
  'file-management.fileTypes.ico': 'ICO图标',
  // 代码类型
  'file-management.fileTypes.js': 'JavaScript',
  'file-management.fileTypes.ts': 'TypeScript',
  'file-management.fileTypes.py': 'Python',
  'file-management.fileTypes.java': 'Java',
  'file-management.fileTypes.c': 'C语言',
  'file-management.fileTypes.cpp': 'C++',
  'file-management.fileTypes.cs': 'C#',
  'file-management.fileTypes.go': 'Go',
  'file-management.fileTypes.rs': 'Rust',
  'file-management.fileTypes.php': 'PHP',
  'file-management.fileTypes.rb': 'Ruby',
  'file-management.fileTypes.swift': 'Swift',
  'file-management.fileTypes.kt': 'Kotlin',
  'file-management.fileTypes.scala': 'Scala',
  'file-management.fileTypes.sh': 'Shell脚本',
  'file-management.fileTypes.bash': 'Bash脚本',
  'file-management.fileTypes.ps1': 'PowerShell脚本',
  'file-management.fileTypes.bat': '批处理文件',
  'file-management.fileTypes.cmd': '命令文件',
  'file-management.fileTypes.html': 'HTML文件',
  'file-management.fileTypes.htm': 'HTML文件',
  'file-management.fileTypes.css': 'CSS样式',
  'file-management.fileTypes.json': 'JSON数据',
  'file-management.fileTypes.xml': 'XML文件',
  'file-management.fileTypes.yaml': 'YAML配置',
  'file-management.fileTypes.yml': 'YAML配置',
  'file-management.fileTypes.properties': '属性配置',
  // 音频类型
  'file-management.fileTypes.mp3': 'MP3音频',
  'file-management.fileTypes.wav': 'WAV音频',
  'file-management.fileTypes.ogg': 'OGG音频',
  'file-management.fileTypes.aac': 'AAC音频',
  'file-management.fileTypes.flac': 'FLAC音频',
  'file-management.fileTypes.m4a': 'M4A音频',
  'file-management.fileTypes.wma': 'WMA音频',
  // 视频类型
  'file-management.fileTypes.mp4': 'MP4视频',
  'file-management.fileTypes.avi': 'AVI视频',
  'file-management.fileTypes.mov': 'MOV视频',
  'file-management.fileTypes.wmv': 'WMV视频',
  'file-management.fileTypes.webm': 'WebM视频',
  'file-management.fileTypes.mkv': 'MKV视频',
  'file-management.fileTypes.3gp': '3GP视频',
  // 压缩类型
  'file-management.fileTypes.zip': 'ZIP压缩包',
  'file-management.fileTypes.rar': 'RAR压缩包',
  'file-management.fileTypes.7z': '7Z压缩包',
  'file-management.fileTypes.tar': 'TAR压缩包',
  'file-management.fileTypes.gz': 'GZ压缩包',
  'file-management.fileTypes.bz2': 'BZ2压缩包',
  'file-management.fileTypes.dmg': 'DMG磁盘镜像',
  'file-management.fileTypes.iso': 'ISO镜像',
  'file-management.fileTypes.xz': 'XZ压缩包',
  // 数据库类型
  'file-management.fileTypes.sql': 'SQL文件',
  'file-management.fileTypes.db': '数据库文件',
  'file-management.fileTypes.sqlite': 'SQLite数据库',
  'file-management.fileTypes.sqlite3': 'SQLite3数据库',
  // 字体类型
  'file-management.fileTypes.ttf': 'TrueType字体',
  'file-management.fileTypes.otf': 'OpenType字体',
  'file-management.fileTypes.woff': 'WOFF字体',
  'file-management.fileTypes.woff2': 'WOFF2字体',
  'file-management.fileTypes.eot': 'EOT字体',
  // 其他类型
  'file-management.fileTypes.exe': '可执行文件',
  'file-management.fileTypes.dll': '动态链接库',
  'file-management.fileTypes.msi': '安装程序',
  // Permission center & governance
  'file-management.permissionCenter.title': '权限中心',
  'file-management.permissionCenter.subtitle':
    '统一配置文件与文件夹的可见性与 ACL 权限',
  'file-management.permissionCenter.reloadAll': '全量刷新',
  'file-management.permissionCenter.forbidden.title': '无访问权限',
  'file-management.permissionCenter.forbidden.subtitle':
    '当前页面只对租户管理员或组织管理员开放',
  'file-management.permissionCenter.tab.file': '文件配置',
  'file-management.permissionCenter.tab.folder': '文件夹配置',
  'file-management.permissionCenter.file.title': '文件配置',
  'file-management.permissionCenter.file.detailTitle': '文件配置详情',
  'file-management.permissionCenter.file.searchPlaceholder': '搜索文件',
  'file-management.permissionCenter.file.exceptionSearchPlaceholder':
    '搜索已设置策略的文件',
  'file-management.permissionCenter.file.addExceptionPlaceholder':
    '搜索文件并新增策略',
  'file-management.permissionCenter.file.appIdPlaceholder': '按来源应用筛选',
  'file-management.permissionCenter.file.refresh': '刷新',
  'file-management.permissionCenter.folder.title': '文件夹配置',
  'file-management.permissionCenter.folder.detailTitle': '文件夹配置详情',
  'file-management.permissionCenter.folder.refresh': '刷新',
  'file-management.permissionCenter.folder.loading': '加载中',
  'file-management.permissionCenter.folder.noActiveStorage':
    '当前没有可用的活跃存储配置，无法加载文件夹树',
  'file-management.permissionCenter.column.fileName': '文件名',
  'file-management.permissionCenter.column.updatedAt': '更新时间',
  'file-management.permissionCenter.column.app': '应用',
  'file-management.permissionCenter.column.visibility': '可见性',
  'file-management.permissionCenter.column.sensitivity': '敏感级别',
  'file-management.permissionCenter.view.admin': '管理员视图',
  'file-management.permissionCenter.view.app': '应用文件',
  'file-management.permissionCenter.visibility.inherit': '沿用策略',
  'file-management.permissionCenter.visibility.private': '应用内可见',
  'file-management.permissionCenter.visibility.custom': '自定义 ACL',
  'file-management.permissionCenter.visibility.organization': '组织可见',
  'file-management.permissionCenter.visibility.tenant': '租户可见',
  'file-management.permissionCenter.sensitivity.normal': '普通',
  'file-management.permissionCenter.sensitivity.confidential': '机密',
  'file-management.permissionCenter.sensitivity.restricted': '受限',
  'file-management.permissionCenter.app.unconfigured': '未配置',
  'file-management.permissionCenter.app.fileManage': '职阅云存储',
  'file-management.permissionCenter.message.loadAppNamesFailed':
    '加载应用名称失败',
  'file-management.permissionCenter.message.loadFilesFailed':
    '加载文件列表失败',
  'file-management.permissionCenter.message.loadFoldersFailed':
    '加载文件夹树失败',
  'file-management.permissionCenter.message.loadAppPolicyFailed':
    '加载应用默认策略失败',
  'file-management.permissionCenter.message.loadFolderPolicyFailed':
    '加载文件夹策略失败',
  'file-management.permissionCenter.message.loadFilePolicyFailed':
    '加载文件有效策略失败',
  'file-management.permissionCenter.message.loadFileExceptionsFailed':
    '加载文件策略列表失败',
  'file-management.permissionCenter.message.saveAppPolicySuccess':
    '应用默认策略已保存',
  'file-management.permissionCenter.message.saveAppPolicyFailed':
    '保存应用默认策略失败',
  'file-management.permissionCenter.message.saveFolderPolicySuccess':
    '文件夹策略已保存',
  'file-management.permissionCenter.message.saveFolderPolicyFailed':
    '保存文件夹策略失败',
  'file-management.permissionCenter.message.saveRootPolicySuccess':
    '根目录策略已保存',
  'file-management.permissionCenter.message.selectSourceAppFirst':
    '请先选择来源应用',
  'file-management.permissionCenter.message.saveFileExceptionSuccess':
    '文件策略已保存',
  'file-management.permissionCenter.message.saveFileExceptionFailed':
    '保存文件策略失败',
  'file-management.permissionCenter.message.clearFileExceptionSuccess':
    '文件策略已清除',
  'file-management.permissionCenter.message.clearFileExceptionFailed':
    '清除文件策略失败',
  'file-management.permissionCenter.column.exception': '例外状态',
  'file-management.permissionCenter.file.exception.yes': '已设置例外',
  'file-management.permissionCenter.file.exception.no': '继承策略',
  'file-management.permissionCenter.sourceApp.placeholder': '选择来源应用',
  'file-management.permissionCenter.appPolicy.hint':
    '应用默认策略是该来源应用下全部资源的兜底权限。',
  'file-management.permissionCenter.action.saveAppPolicy': '保存默认策略',
  'file-management.permissionCenter.action.saveFolderPolicy': '保存文件夹策略',
  'file-management.permissionCenter.action.saveFileException': '保存文件策略',
  'file-management.permissionCenter.action.clearFileException': '清除文件策略',
  'file-management.permissionCenter.folder.mode.inherit': '继承父级',
  'file-management.permissionCenter.folder.mode.custom': '自定义策略',
  'file-management.permissionCenter.folder.inheritEmpty':
    '父级暂无显式策略规则',
  'file-management.permissionCenter.folder.rootNode': '根目录',
  'file-management.permissionCenter.folder.rootHint':
    '根目录策略等同于应用默认策略',
  'file-management.permissionCenter.folder.effectiveFrom':
    '当前生效来源：{value}',
  'file-management.permissionCenter.folder.defaultPolicy': '默认文件夹策略',
  'file-management.permissionCenter.folder.selectFolder':
    '请选择文件夹进行配置',
  'file-management.permissionCenter.fileException.title': '文件策略',
  'file-management.permissionCenter.fileException.addRules': '增量授权规则',
  'file-management.permissionCenter.fileException.removeRules': '收紧授权规则',
  'file-management.permissionCenter.fileException.addRemoveRule':
    '新增收紧规则',
  'file-management.permissionCenter.file.selectFile': '请选择文件进行策略配置',
  'file-management.permissionCenter.tab.appDefault': '应用默认策略',
  'file-management.permissionCenter.tab.folderPolicy': '文件夹策略',
  'file-management.permissionCenter.tab.fileException': '文件策略',
  'file-management.governance.title.file': '文件配置',
  'file-management.governance.title.folder': '文件夹配置',
  'file-management.governance.title.fileException': '文件策略',
  'file-management.governance.tab.overview': '配置',
  'file-management.governance.tab.acl': 'ACL',
  'file-management.governance.desc.resourceUuid': '资源 UUID',
  'file-management.governance.desc.fileName': '文件名',
  'file-management.governance.desc.inheritedFrom': '继承来源',
  'file-management.governance.desc.app': '应用',
  'file-management.governance.desc.lifecycle': '生命周期',
  'file-management.governance.desc.effectivePermissions': '有效权限',
  'file-management.governance.desc.none': '无',
  'file-management.governance.form.fileName': '文件名',
  'file-management.governance.form.description': '描述',
  'file-management.governance.form.category': '分类',
  'file-management.governance.form.tags': '标签',
  'file-management.governance.form.folderName': '文件夹名称',
  'file-management.governance.form.visibility': '可见性',
  'file-management.governance.form.sensitivity': '敏感级别',
  'file-management.governance.form.sourceAppId': '来源应用 ID',
  'file-management.governance.form.sourceAppPlaceholder':
    '例如 file_manage / knowledge',
  'file-management.governance.form.saveOverview': '保存配置',
  'file-management.governance.visibility.inherit': '沿用来源应用策略',
  'file-management.governance.visibility.private': '应用内可见',
  'file-management.governance.visibility.custom': '自定义 ACL',
  'file-management.governance.sensitivity.normal': '普通',
  'file-management.governance.sensitivity.confidential': '机密',
  'file-management.governance.sensitivity.restricted': '受限',
  'file-management.governance.lifecycle.title': '生命周期',
  'file-management.governance.lifecycle.archive': '归档',
  'file-management.governance.lifecycle.restore': '恢复',
  'file-management.governance.lifecycle.recycle': '移入回收站',
  'file-management.governance.lifecycle.purge': '彻底清理',
  'file-management.governance.lifecycle.confirmRecycle':
    '确认将文件移入回收站？',
  'file-management.governance.lifecycle.confirmPurgeTitle':
    '确认彻底清理该文件？',
  'file-management.governance.lifecycle.confirmPurgeDesc':
    '清理后将尝试删除对象存储中的文件，且不会再出现在文件列表中。',
  'file-management.governance.lifecycle.help':
    '活跃文件可被正常访问；归档文件会保留但标记为非活跃；移入回收站后仅支持恢复或清理。',
  'file-management.governance.lifecycle.status.active': '活跃',
  'file-management.governance.lifecycle.status.uploading': '上传中',
  'file-management.governance.lifecycle.status.archived': '已归档',
  'file-management.governance.lifecycle.status.recycled': '回收站',
  'file-management.governance.lifecycle.status.purged': '已清理',
  'file-management.governance.empty.selectResource': '请选择一个资源开始配置',
  'file-management.governance.empty.noGovernancePermission':
    '仅租户管理员或组织管理员可查看配置',
  'file-management.governance.empty.fileOnly':
    '文件夹 ACL 请在“权限中心 > 文件夹策略”中配置。',
  'file-management.governance.message.loadDetailFailed': '加载治理详情失败',
  'file-management.governance.message.saveOverviewSuccess': '配置已保存',
  'file-management.governance.message.saveOverviewFailed': '保存配置失败',
  'file-management.governance.message.noPermissionToSave': '暂无权限保存配置',
  'file-management.governance.message.saveAclSuccess': 'ACL 已保存',
  'file-management.governance.message.saveAclFailed': '保存 ACL 失败',
  'file-management.governance.message.updateLifecycleFailed':
    '更新生命周期失败',
  'file-management.governance.message.archiveSuccess': '文件已归档',
  'file-management.governance.message.restoreSuccess': '文件已恢复为活跃状态',
  'file-management.governance.message.recycleSuccess': '文件已移入回收站',
  'file-management.governance.message.purgeSuccess': '文件已彻底清理',
  'file-management.governance.message.clearFileExceptionSuccess':
    '文件策略已清除',
  'file-management.governance.message.clearFileExceptionFailed':
    '清除文件策略失败',
  'file-management.governance.fileException.addRules': '增量授权规则',
  'file-management.governance.fileException.removeRules': '收紧授权规则',
  'file-management.governance.fileException.addRemoveRule': '新增收紧规则',
  'file-management.governance.fileException.save': '保存策略',
  'file-management.governance.fileException.clear': '清除策略',
  'file-management.aclPackEditor.column.subject': '授权主体',
  'file-management.aclPackEditor.column.subjectId': '主体标识',
  'file-management.aclPackEditor.column.permissionPack': '权限包',
  'file-management.aclPackEditor.column.expiresAt': '过期时间',
  'file-management.aclPackEditor.expiresAt.permanent': '永久有效',
  'file-management.aclPackEditor.column.action': '操作',
  'file-management.aclPackEditor.subjectId.placeholder':
    '角色/应用主体可手动输入标识',
  'file-management.aclPackEditor.addRule': '新增规则',
  'file-management.aclPackEditor.empty': '暂无 ACL 规则',
  'file-management.subjectPicker.type.member': '成员',
  'file-management.subjectPicker.type.organization': '组织/租户',
  'file-management.subjectPicker.type.role': '角色',
  'file-management.subjectPicker.type.app': '应用',
  'file-management.subjectPicker.member.placeholder': '搜索成员（昵称/手机号）',
  'file-management.subjectPicker.organization.placeholder': '选择组织/租户',
  'file-management.subjectPicker.role.placeholder': '请选择角色',
  'file-management.subjectPicker.role.admin': '管理员',
  'file-management.subjectPicker.role.everyone': '所有人',
  'file-management.subjectPicker.app.placeholder': '请输入应用标识',
  'file-management.subjectPicker.empty': '暂无数据',
  'file-management.aclPack.read': '可读',
  'file-management.aclPack.edit': '可编辑',
  'file-management.aclPack.manage': '可治理',
  'file-management.aclPack.read.desc': '可读：查看/预览/下载',
  'file-management.aclPack.edit.desc':
    '可编辑：可读 + 上传/重命名/移动/替换内容/修改元数据',
  'file-management.aclPack.manage.desc':
    '可治理：可编辑 + 删除/归档/恢复/分享/管理 ACL/管理引用',
  'file-management.permission.label.view': '查看',
  'file-management.permission.label.preview': '预览',
  'file-management.permission.label.download': '下载',
  'file-management.permission.label.upload': '上传',
  'file-management.permission.label.rename': '重命名',
  'file-management.permission.label.move': '移动',
  'file-management.permission.label.replace_content': '替换内容',
  'file-management.permission.label.edit_metadata': '修改元数据',
  'file-management.permission.label.delete': '删除',
  'file-management.permission.label.archive': '归档',
  'file-management.permission.label.restore': '恢复',
  'file-management.permission.label.share': '分享',
  'file-management.permission.label.manage_acl': '管理 ACL',
  'file-management.permission.label.manage_reference': '管理引用',
  'file-management.fileLibrary.governanceException.noPermission':
    '仅租户管理员或组织管理员可查看文件策略',
  'file-management.fileLibrary.share.onlyOwnerOrAdmin':
    '仅租户/组织管理员或文件上传者可分享该文件',
  'file-management.fileLibrary.action.exception': '文件策略',
  'file-management.fileLibrary.drawer.exceptionTitle': '文件策略: {name}',
  'file-management.appBrowser.searchApp': '搜索应用名称或 ID',
  'file-management.appBrowser.deleteFolder': '删除文件夹',
  'file-management.appBrowser.deleteFolderTitle': '确定删除文件夹“{name}”吗？',
  'file-management.appBrowser.deleteFolderDescription':
    '所选文件夹及其中所有文件、子文件夹将一并删除，无法恢复。',
  'file-management.appBrowser.deleteSelectedTitle':
    '确定删除选中的文件和文件夹吗？',
  'file-management.appBrowser.deleteConfirm': '确认删除',
  'file-management.appBrowser.deleteCancel': '取消',
  'file-management.appBrowser.deleteSuccess': '删除成功',
  'file-management.appBrowser.deleteFailed':
    '删除失败，可能已有部分内容被删除，请刷新后检查。',
  'file-management.appBrowser.deletePartial':
    '已删除 {deleted} 个对象，{failed} 个删除失败，请刷新后重试。',
};
